<template>
    <div class="com-codics-hbb-order-admin-user-body">
        <div class="com-codics-hbb-order-admin-user-bar-content">
            <el-cascader class="com-codics-hbb-order-admin-user-bar-pick" :options="roleData" v-model="memsList"
                placeholder="请选择角色" :props="{ value: 'id', label: 'role', checkStrictly: true, children: 'children' }"
                clearable @change="roleChange"></el-cascader>
            <el-input class="com-codics-hbb-order-admin-user-bar-input" v-model="searchTxt"
                placeholder="请输入账号/昵称/邮箱/手机号..." clearable @input="searchChange">
            </el-input>
            <MyButton style="float: left;margin-left: 15px;padding:0 15px;" @click.native="searchUsers">&#xe86e;
            </MyButton>
            <el-dropdown style="float: right;" @command="addUserCommand">
                <MyButton style="float: right;">&#xe632; 添加员工</MyButton>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item, index) in ['直接创建']" :key="index" :command="item">{{ item
                        }}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <!-- , '邀请注册' -->
            <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info" icon-color="red"
                title="您确定要删除选中的用户数据吗？" @confirm="deleteUsersFuc">
                <MyButton style="float: right;margin-right: 15px;padding:0 15px;" slot="reference">&#xe850;</MyButton>
            </el-popconfirm>
            <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info" icon-color="red"
                title="您确定要重置选中用户的密码为123456吗？" @confirm="repassUsersFuc">
                <MyButton style="float: right;margin-right: 15px;padding:0 15px;" slot="reference">&#xe82d;</MyButton>
            </el-popconfirm>
        </div>
        <div class="com-codics-hbb-order-admin-user-bar-content com-codics-hbb-order-admin-user-bar-content2"
            style="margin-top: 10px;">
            <el-table :data="searchTxt == '' ? tableData : searchData" style="width: 100%;transition: .3s;"
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="50" :selectable="row => row.member !== 0">
                </el-table-column>
                <el-table-column prop="id" label="ID" width="80">
                </el-table-column>
                <el-table-column prop="account" label="账号" width="180">
                </el-table-column>
                <el-table-column prop="himg" label="头像" width="60">
                    <template slot-scope="scope">
                        <el-image style="top:3.5px;height:30px;width:30px;"
                            :src="scope.row.himg == null ? 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png' : ('https://cdn.bosscaigou.com/' + scope.row.himg)"
                            fit="fill">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="nickname" label="昵称" width="180">
                </el-table-column>
                <!-- <el-table-column prop="sex" label="性别" width="70"
                :filters="[{ text: '未知', value: 0 }, { text: '男性', value: 1 }, { text: '女性', value: 2 }]"
                :filter-method="sexFilter" filter-placement="bottom-end">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.sex == 0 ? 'info' : (scope.row.sex == 1 ? '' : 'danger')"
                        disable-transitions>{{ scope.row.sex == 0 ? '未知' :
                    (scope.row.sex == 1 ? '男性' : '女性') }}</el-tag>
                </template>
            </el-table-column> -->
                <el-table-column prop="member" label="权限" width="170"
                    :filters="[{ text: '管理', value: 0 }, { text: '商户', value: 1 }, { text: '用户', value: 2 }]"
                    :filter-method="memberFilter" filter-placement="bottom-end">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.member == -1 ? 'danger' : (scope.row.member == 0 ? 'success' : 'info')"
                            disable-transitions size="mini">{{
                            scope.row.member == -1 ? '未绑定' : scope.row?.role?.role }}</el-tag>&nbsp;&nbsp;<span
                            v-show="scope.row.member != 0" class="iconfont"
                            style="font-size: 12px;color: chocolate;user-select: none;cursor: pointer;"
                            @click="nowId = scope.row.id; roleDialog = true;">&#xe79c; 换绑</span>
                    </template>
                </el-table-column>
                <el-table-column prop="state" label="状态" width="70"
                    :filters="[{ text: '正常', value: 0 }, { text: '冻结', value: 1 }, { text: '封禁', value: 2 }]"
                    :filter-method="stateFilter" filter-placement="bottom-end">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.state == 0 ? 'success' : (scope.row.state == 1 ? 'info' : 'danger')"
                            disable-transitions size="mini">{{ scope.row.state == 0 ? '正常'
                            : (scope.row.state == 1 ? '冻结' : '封禁') }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createtime" label="注册时间" width="280">
                    <template slot-scope="scope">
                        {{ initTime(scope.row.createtime) }}
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="wxkey" label="微信" width="80"
                :filters="[{ text: '已绑定', value: 0 }, { text: '未绑定', value: 1 }]" :filter-method="wxFilter"
                filter-placement="bottom-end">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.wxkey != null ? '' : 'warning'" disable-transitions>{{ scope.row.wxkey !=
                    null
                    ? '已绑定'
                    : '未绑定' }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="qkey" label="QQ" width="80"
                :filters="[{ text: '已绑定', value: 0 }, { text: '未绑定', value: 1 }]" :filter-method="qqFilter"
                filter-placement="bottom-end">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.qkey != null ? '' : 'warning'" disable-transitions>{{ scope.row.qkey !=
                    null ?
                    '已绑定'
                    : '未绑定' }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="email" label="邮箱" width="200">
            </el-table-column>
            <el-table-column prop="phone" label="手机" width="110">
            </el-table-column> -->
                <el-table-column align="right" label="操作" min-width="150">
                    <template slot-scope="scope">
                        <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info"
                            icon-color="red" title="您确定要删除当前用户数据吗？" @confirm="deleteUsersFuc([scope.row.id])">
                            <MyButton v-show="scope.row.member != 0" size="small" type="danger" style="float: right;"
                                slot="reference">删除</MyButton>
                        </el-popconfirm>
                        <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info"
                            icon-color="red" title="您确定要重置当前用户密码为123456吗？" @confirm="repassUsersFuc([scope.row.id])">
                            <MyButton v-show="scope.row.member != 0" size="small"
                                style="float: right;margin-right: 10px;" slot="reference">重置
                            </MyButton>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="codics-aonaer-info-sys-news-pagination" background @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :current-page="searchTxt == '' ? currentPage : searchPage"
                :page-sizes="[10, 20, 30, 40]" :page-size="searchTxt == '' ? dataSize : searchSize"
                layout="total, sizes, prev, pager, next, jumper, slot" :total="searchTxt == '' ? maxSize : searchMax">
            </el-pagination>
        </div>
        <RegisterDialog v-model="registerDialog"></RegisterDialog>
        <RegisterDialog2 v-model="registerDialog2"></RegisterDialog2>
        <MyDialog :visible.sync="roleDialog" title="修改角色">
            <el-cascader
                style="margin-bottom: 70px;width: calc(50% - 7.5px) !important;position: relative;float: left;box-sizing: border-box;margin-top: 20px;font-size: 10px !important;"
                :options="roleData" clearable v-model="nowRole" placeholder="请选择用户角色" size="small"
                :props="{ value: 'id', label: 'role', checkStrictly: true, children: 'children' }">
            </el-cascader>
            <el-button type="success" style="position: absolute;margin: auto;right: 15px;bottom: 15px;" size="mini"
                @click="userRoleFuc">确认修改</el-button>
        </MyDialog>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import MyButton from '@/components/MyButton';
import MyDialog from '@/components/MyDialog';
import RegisterDialog from '@/components/RegisterDialog';
import RegisterDialog2 from '@/components/RegisterDialog2';
import { listUsers, deleteUsers, repassUsers, listRole, userRole } from '@/api';
export default {
    data() {
        return {
            nowId: null,
            nowRole: [],
            roleDialog: false,
            registerDialog: false,
            registerDialog2: false,
            tableData: [],
            searchData: [],
            selectData: [],
            roleData: [],
            memsList: [],
            searchTxt: '',
            nowSearchTxt: '',
            currentPage: 1,
            searchPage: 1,
            dataSize: 10,
            searchSize: 10,
            maxSize: 0,
            searchMax: 0
        }
    },
    components: {
        MyButton,
        MyDialog,
        RegisterDialog,
        RegisterDialog2
    },
    mounted() {
        this.listUsersFuc();
        this.listRoleFuc();
    },
    methods: {
        async userRoleFuc() {
            if (this.nowId == null || this.nowId == '') {
                this.$message.error('请先选择要修改的用户！');
                return;
            }
            if (this.nowRole.length == 0) {
                this.$message.error('请选择用户角色！');
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await userRole({
                id: this.nowId,
                role: this.nowRole[this.nowRole.length - 1]
            });
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '修改成功！',
                    type: 'success'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 300);
            } else {
                if (data.code == 401) return;

                this.$message.error(data.message);
            }
        },
        roleChange() {

            if (this.nowSearchTxt == '') {

                this.currentPage = 1;

                this.dataSize = 10;

                this.tableData = [];

                this.listUsersFuc();

            } else {

                this.searchPage = 1;

                this.searchSize = 10;

                this.searchData = [];

                this.listUsersFuc();

            }

        },
        async listRoleFuc() {

            const data = await listRole();

            if (data.code == 200) {

                this.roleData = data.data;

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        addUserCommand(a) {
            switch (a) {
                case '直接创建':
                    this.registerDialog2 = true;
                    break;
                case '邀请注册':
                    this.registerDialog = true;
                    break;
            }
        },
        searchUsers() {

            if (this.searchTxt == '') {

                this.$message.error('请先输入要搜索的内容！');

                return;

            }

            this.searchPage = 1;

            this.searchMax = 0;

            this.searchData = [];

            this.nowSearchTxt = this.searchTxt;

            this.listUsersFuc();

        },
        async listUsersFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await listUsers({
                key: this.nowSearchTxt,
                pge: this.searchTxt == '' ? this.currentPage : this.searchPage,
                psz: this.searchTxt == '' ? this.dataSize : this.searchSize,
                mems: this.memsList
            });

            loading.close();

            if (data.code == 200) {

                if (this.searchTxt == '') {

                    this.tableData = data.data;

                    this.maxSize = data.count;

                } else {

                    this.searchData = data.data;

                    this.searchMax = data.count;

                }

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async repassUsersFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要重置的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await repassUsers({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '共' + data.count + '条数据重置成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async deleteUsersFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要删除的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await deleteUsers({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: data.count + '条数据删除成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        stateFilter(v, r, c) {

            return r.state === v;

        },
        memberFilter(v, r, c) {

            return r.member === v;

        },
        handleSizeChange(val) {
            if (this.searchTxt == '') {
                this.dataSize = val;
            } else {
                this.searchSize = val;
            }
            this.listUsersFuc();
        },
        handleCurrentChange(val) {
            if (this.searchTxt == '') {
                this.currentPage = val;
            } else {
                this.searchPage = val;
            }
            this.listUsersFuc();
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        searchChange(a) {
            if (a == '') {
                this.searchPage = 1;
                this.searchData = [];
                this.searchMax = 0;
                this.searchSize = 10;
                this.nowSearchTxt = '';
            }
        },
        initTime(str) {
            return dayjs(str).format('YYYY-MM-DD HH:mm:ss');
        },
    }
}
</script>

<style>
.com-codics-hbb-order-admin-user-body {
    height: fit-content;
    min-height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
}

:root {
    --el-input-bg-color: #FFF;
    --el-input-l-color: #DCDFE6;
    --el-input-l-hover-color: #C0C4CC;
    --el-input-l-focus-color: #000;
    --el-table-bg-color: #FFF;
    --el-table-l-color: #EBEEF5;
    --el-table-bg-hover-color: #F5F7FA;
    --el-table-body-font-color: #606266;
    --el-table-page-bg-color: #FFF;
    --el-table-page-bg-active-color: #333;
    --el-table-page-font-color: #606266;
    --el-table-page-font-active-color: #FFF;
}

:root[data-theme="dark"] {
    --el-input-bg-color: #333;
    --el-input-l-color: #444;
    --el-input-l-hover-color: #555;
    --el-input-l-focus-color: #888;
    --el-table-bg-color: #333;
    --el-table-l-color: #444;
    --el-table-bg-hover-color: #555;
    --el-table-body-font-color: #999;
    --el-table-page-bg-color: #292B2C;
    --el-table-page-bg-active-color: #FFF;
    --el-table-page-font-color: #AAA;
    --el-table-page-font-active-color: #333;
}

.el-input__inner {
    background-color: var(--el-input-bg-color) !important;
    border-color: var(--el-input-l-color) !important;
}

.el-input__inner:hover {
    border-color: var(--el-input-l-hover-color) !important;
}

.el-input__inner:focus {
    border-color: var(--el-input-l-focus-color) !important;
}

.el-table th.el-table__cell {
    background-color: var(--el-table-bg-color) !important;
}

.el-table tr {
    background-color: var(--el-table-bg-color) !important;
}

.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid var(--el-table-l-color) !important;
}

.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
    background-color: var(--el-table-bg-hover-color) !important;
}

.el-table--border::after,
.el-table--group::after,
.el-table::before {
    background-color: var(--el-table-l-color) !important;
}

.el-table {
    color: var(--el-table-body-font-color) !important;
}

.el-table,
.el-table__expanded-cell {
    background: var(--el-table-bg-color) !important;
}

.com-codics-hbb-order-admin-user-bar-content {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: var(--sbar-bg-color);
    border-radius: 6px;
    border: 1px solid var(--sbar-l-3-color);
    padding: 15px;
    transition: .3s;
}

.com-codics-hbb-order-admin-user-bar-content2 {
    box-sizing: border-box;
    padding: 20px;
}

.com-codics-hbb-order-admin-user-bar-pick {
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-right: 15px;
}

.com-codics-hbb-order-admin-user-bar-input {
    width: 300px !important;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-news-pagination {
    height: fit-content;
    position: relative;
    float: left;
    /* left: 50%; */
    margin-top: 20px;
    /* transform: translateX(-50%); */
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
    background-color: var(--el-table-page-bg-color) !important;
    color: var(--el-table-page-font-color) !important;
}

.el-pagination.is-background .el-pager .active {
    background-color: var(--el-table-page-bg-active-color) !important;
    color: var(--el-table-page-font-active-color) !important;
}
</style>